export default __webpack_public_path__ + "static/media/2026-03-22 18.08.25.a3a291b4.jpg";